import { render, staticRenderFns } from "./selectButton.vue?vue&type=template&id=248de333&scoped=true&"
import script from "./selectButton.vue?vue&type=script&lang=js&"
export * from "./selectButton.vue?vue&type=script&lang=js&"
import style0 from "./selectButton.vue?vue&type=style&index=0&id=248de333&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248de333",
  null
  
)

export default component.exports